const beforeItems = [
  { icon: 'ri-phone-missed-line', text: 'Calls go to voicemail and leads are lost' },
  { icon: 'ri-calendar-close-line', text: 'Scheduling done via phone tag and spreadsheets' },
  { icon: 'ri-user-unfollow-line', text: 'Estimates sent once, never followed up' },
  { icon: 'ri-question-mark', text: 'No visibility into job pipeline or revenue status' },
  { icon: 'ri-alarm-warning-line', text: 'Reactive to problems instead of proactive systems' },
  { icon: 'ri-team-line', text: 'Staff overwhelmed with repetitive admin tasks' },
];

const afterItems = [
  { icon: 'ri-phone-fill', text: 'AI captures and qualifies every inbound lead 24/7' },
  { icon: 'ri-calendar-check-fill', text: 'Customers self-book; jobs auto-populate dispatch' },
  { icon: 'ri-mail-check-fill', text: 'Multi-step sequences follow up until conversion' },
  { icon: 'ri-dashboard-fill', text: 'Live pipeline dashboard shows every job in real time' },
  { icon: 'ri-shield-check-fill', text: 'Structured workflows prevent revenue from leaking' },
  { icon: 'ri-robot-fill', text: 'Automation handles admin so your team focuses on jobs' },
];

export default function BeforeAfterSection() {
  return (
    <section className="bg-[#0F172A] py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block bg-white/10 text-slate-300 text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wider mb-4">
            The Transformation
          </span>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-white">
            Before vs. After{' '}
            <span className="text-amber-400">Omega</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="bg-red-950/40 border border-red-900/50 rounded-2xl p-8">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-10 h-10 flex items-center justify-center bg-red-500/20 rounded-xl">
                <i className="ri-close-circle-line text-red-400 text-xl" />
              </div>
              <div>
                <h3 className="text-white text-xl font-bold">Before Omega</h3>
                <p className="text-red-400 text-xs font-medium mt-0.5">Manual · Inconsistent · Reactive</p>
              </div>
            </div>
            <ul className="space-y-4">
              {beforeItems.map((item) => (
                <li key={item.text} className="flex items-start gap-4">
                  <div className="w-9 h-9 flex items-center justify-center bg-red-500/15 rounded-lg flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-red-400 text-base`} />
                  </div>
                  <span className="text-slate-300 text-sm leading-relaxed pt-1.5">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-emerald-950/40 border border-emerald-900/50 rounded-2xl p-8">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-10 h-10 flex items-center justify-center bg-green-500/20 rounded-xl">
                <i className="ri-check-double-line text-green-400 text-xl" />
              </div>
              <div>
                <h3 className="text-white text-xl font-bold">After Omega</h3>
                <p className="text-green-400 text-xs font-medium mt-0.5">Automated · Structured · Scalable</p>
              </div>
            </div>
            <ul className="space-y-4">
              {afterItems.map((item) => (
                <li key={item.text} className="flex items-start gap-4">
                  <div className="w-9 h-9 flex items-center justify-center bg-green-500/15 rounded-lg flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-green-400 text-base`} />
                  </div>
                  <span className="text-slate-300 text-sm leading-relaxed pt-1.5">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
